











































































/** @format */

import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import { PARKING_LOT_LIST } from '../router-names';
import { Mutation } from 'vuex-class';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import AddEditModal from './components/edit-model.vue';
import { iotConfigUpdate, iotConfigList } from '@/api/parking-lot-management/index';
@Component({
  name: 'IOTConfig',
  components: { ParkingLotSearch, AddEditModal }
})
export default class IOTConfig extends Mixins(TableMixin, TableWidthMixin) {
  headTitle = 'IOT配置'; // 标题
  // 面包屑数据
  get breadcrumbNav() {
    return [
      {
        label: '车场管理',
        location: {
          name: PARKING_LOT_LIST
        }
      },
      {
        label: this.headTitle
      }
    ];
  }
  //订阅状态
  statusOptions: any[] = [
    { value: '', label: '全部' },
    { value: '11', label: '已订阅' },
    { value: '00', label: '未订阅' }
  ];
  //搜索条件
  filterParam: any = {
    parkIds: [], // 车场ID集合,多车场逗号分隔
    iotEdgeAppid: '', // appid
    iotEdgeAppwatchStatus: '' // 状态
  };
  // table数据
  private tableData: any[] = [];

  // 加载中
  loading: boolean = false;
  get tableColums() {
    return [
      {
        title: '序号',
        width: 55,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '车场名称',
        dataIndex: 'parkName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: 'IOT项目名称',
        dataIndex: 'iotProjectName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: 'APPKey',
        dataIndex: 'iotEdgeAppkey',
        width: 160,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: 'APPSecret',
        dataIndex: 'iotEdgeAppsecret',
        width: 240,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: 'APPId',
        dataIndex: 'iotEdgeAppid',
        width: 240,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '订阅状态',
        dataIndex: 'iotEdgeAppwatchStatus',
        width: 120,
        scopedSlots: { customRender: 'iotEdgeAppwatchStatus' }
      },
      {
        title: '操作时间',
        dataIndex: 'makeTime',
        width: 200
      },
      {
        title: '操作人',
        dataIndex: 'makeUser',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '操作',
        dataIndex: 'operation',
        fixed: 'right',
        width: 180,
        scopedSlots: { customRender: 'operation' }
      }
    ];
  }
  editModel: boolean = false; //弹出框是否显示
  addEditModalData: any = null;
  //table初始化
  async fetchTableData(refresh?: any) {
    if (refresh) this.current = 1;
    if (this.tableLoading) return;
    // @ts-ignore
    this.tableLoading = true;
    try {
      const { ...rest } = this.filterParam;
      const { status, code, msg, data } = await iotConfigList({
        ...rest,
        current: this.current,
        pageSize: this.pageSize
      });
      const { datas, total, totalPage, currPage, pageSize } = data;
      this.tableData = datas;
      this.total = total - 0;
      this.current = currPage - 0;
      // this.pageSize = pageSize - 0
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      // @ts-ignore
      this.tableLoading = false;
    }
  }
  //分页
  handleTableChange(val: any) {
    this.current = val.current;
    this.pageSize = val.pageSize;
    this.fetchTableData();
  }
  //点击搜索
  searchTable() {
    this.fetchTableData(true);
  }
  //清空table
  onTableFilterClear({ defaultParkIdList }) {
    this.filterParam = {
      parkId: defaultParkIdList
    };
    this.searchTable();
  }
  //编辑
  async editItem(record?: any) {
    try {
      //const { status, code, msg, data } = await businessDetail({ id: val.id })
      const data = record;
      this.addEditModalData = { ...data };
    } catch (error) {
      return this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    }
    this.editModel = true;
  }
  //是否订阅
  async isSubscribe(record) {
    try {
      const { status, code, msg, data } = await iotConfigUpdate({
        parkIds: [record.parkId],
        iotEdgeAppkey: record.iotEdgeAppkey,
        iotEdgeAppsecret: record.iotEdgeAppsecret,
        iotEdgeAppid: record.iotEdgeAppid,
        iotEdgeAppwatchStatus: record.iotEdgeAppwatchStatus == '00' ? '11' : '00'
      });
      this.$message.success(`${record.iotEdgeAppwatchStatus == '00' ? '订阅' : '取消订阅'}成功`);
      this.fetchTableData();
    } catch (error) {
      return this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    }
  }
  //弹窗取消
  handleModalCancel() {
    this.editModel = false;
  }
  //弹窗保存
  handleModalCreate() {
    this.editModel = false;
    this.fetchTableData(true);
  }
  created() {
    this.fetchTableData();
  }
}
